module.exports = __webpack_public_path__ + "static/img/30_1.c50216b.png";


//////////////////
// WEBPACK FOOTER
// ./static/officeImg/index/30_1.png
// module id = Doa3
// module chunks = 1